import { type CrossBrandMallHomeCampaign } from '@hooks-api/types/dataModel/cross-brand-mall'
import { useEffect } from 'react'
import { useBrandTopSellers } from '../hooks/use-brand-top-sellers'
import { type BrandAvailability } from '../hooks/use-eligible-brand-selection'

interface BrandTopSellerAvailabilityCheckerProps {
  campaign: CrossBrandMallHomeCampaign
  onAvailabilityChange: (campaignId: number, availability: BrandAvailability) => void
}

/**
 * 預載該品牌的 catalog API，依熱銷結果回報「此品牌是否有熱銷可顯示」。
 */
export const BrandTopSellerAvailabilityChecker = (props: BrandTopSellerAvailabilityCheckerProps) => {
  const { campaign, onAvailabilityChange } = props

  const { productCardEntries, isProductsLoading } = useBrandTopSellers({ campaign })

  useEffect(function reportTopSellerAvailability() {
    onAvailabilityChange(campaign.campaign_id, {
      hasContent: productCardEntries.length > 0,
      isLoading: isProductsLoading,
    })
  }, [campaign.campaign_id, productCardEntries.length, isProductsLoading, onAvailabilityChange])

  return null
}
